import(/* webpackMode: "eager" */ "/home/interim/frontend/app/accessibility/page.tsx");
